// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputs_inputLabel__cmL1u {
    text-align: left;
    color: #4B5563;
}

.inputs_inputLabel__cmL1u:first-letter {
    text-transform: uppercase;
}

.inputs_inputBorderDefault__vNi7I {
    padding: 0.625rem 0.75rem !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 8px !important;
    font-size: 1rem !important;
    color: #334155 !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.inputs_inputBorderDefault__vNi7I:focus {
    border-color: #818cf8 !important;
    outline: none !important;
    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.2) !important;
}

/* RADIO */

.inputs_customRadio__vWOKw {
    display: flex;
    flex-direction: column;
}

.inputs_customRadio__vWOKw .inputs_radioOption__wAzPr {
    display: flex;
    align-items: center;
    margin-bottom: 0.3rem;
}

.inputs_customRadio__vWOKw input[type="radio"] {
    display: none;
}

.inputs_customRadio__vWOKw label {
    display: inline-block;
    position: relative;
    padding-left: 1.8rem;
    cursor: pointer;
    font-size: 16px;
    color: #6B728C;
}

.inputs_customRadio__vWOKw label:before {
    content: "";
    display: inline-block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1.2rem;
    height: 1.2rem;
    border: 1px solid #D9DDE2;
    border-radius: 50%;
}

.inputs_customRadio__vWOKw label:after {
    content: "";
    display: none;
    position: absolute;
    left: 0.25rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0.7rem;
    height: 0.7rem;
    background-color: #4A4DBB;
    border-radius: 50%;
}

.inputs_customRadio__vWOKw input[type="radio"]:checked + label:before {
    border: 1px solid #4A4DBB;
}

.inputs_customRadio__vWOKw input[type="radio"]:checked + label:after {
    display: inline-block;
}

/* SELECT */

.inputs_customSelect__Utjd\\+ {
    position: relative;
    /* Sin clip aquí: .floatingLabel es absolute y textos largos quedarían recortados; el botón ya limita el texto con overflow-x: hidden */
    overflow: visible;
}

.inputs_customSelectOpen__iMV3X {
    z-index: 200;
}

.inputs_customSelect__Utjd\\+ .inputs_dropdownButton__fl-JL {
    height: 43px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.625rem 0.75rem;
    font-size: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background-color: #fff;
    cursor: pointer;
    color: #334155 !important;
    overflow-x: hidden;
    overflow-y: hidden;
    white-space: nowrap;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.inputs_customSelect__Utjd\\+ .inputs_dropdownButton__fl-JL:focus-visible,
.inputs_customSelect__Utjd\\+ .inputs_dropdownButton__fl-JL:hover {
    border-color: #94a3b8;
}

.inputs_customSelect__Utjd\\+ .inputs_dropdownButton__fl-JL:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.2);
}

.inputs_customSelect__Utjd\\+ .inputs_dropdownOptions__2xnyY {
    color: #334155;
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    display: none;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow:
        0 10px 15px -3px rgba(15, 23, 42, 0.08),
        0 4px 6px -4px rgba(15, 23, 42, 0.06);
    cursor: pointer;
    z-index: 100;
    overflow: hidden;
    text-align: left;
}

.inputs_customSelect__Utjd\\+ .inputs_dropdownOptions__2xnyY.inputs_show__sqIM1 {
    display: block;
}

.inputs_dropdownOption__w0t3p {
    padding: 0.5rem 0.75rem;
    font-size: 0.95rem;
    font-weight: 500;
    text-align: left;
    border-bottom: 1px solid #f1f5f9;
    background-color: #fff;
}

.inputs_dropdownOption__w0t3p:last-child {
    border-bottom: none;
}

.inputs_dropdownOptionTinted__fx\\+0O {
    background-color: #f8fafc;
}

.inputs_dropdownOption__w0t3p:hover {
    background-color: #f1f5f9 !important;
}

.inputs_dropdownOptionSelected__lgiEI {
    background-color: #eef2ff !important;
    color: #3730a3 !important;
    font-weight: 600 !important;
}

/* FILE */

.inputs_fileInputOutsideContainer__HuJnR {
    background-color: #FFFFFF;
    border-radius: 6px;
    margin: 0 0 0 0;
}

.inputs_fileInputContainer__la0Xk {
    position: relative;
    display: inline-block;
    width: 100%;
}

.inputs_fileInput__K3Nr5 {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-color: #333;
    border-radius: 5px;
}

.inputs_fileInput__K3Nr5:focus {
    border: 1px dashed #4A4DB9;
}

.inputs_uploadText__GGXtI {
    text-align: center;
    color: #333333CC;
    white-space: nowrap;
    font-size: 14px;
}

/* Modo cómodo (modal Subir documento): clase raíz por si hijos usan selectores descendientes */
.inputs_fileInputComfortable__if-uf {
    width: 100%;
}

/* Zona dashed — modal Subir documento (finura + centrado) */
.inputs_fileInputComfortableDrop__TuTb5 {
  border: 1px dashed #c5cad3;
  border-radius: 8px;
  min-height: 3.875rem;
  padding: 0.5rem 0.625rem !important;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  background-color: #fafbfc;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;
}

.inputs_fileInputComfortableDropActive__z6D7u {
  border-color: #818cf8;
  background-color: rgba(99, 102, 241, 0.04);
}

/* Zona de drop más amplias (texto multi-línea) */
.inputs_fileInputComfortable__if-uf .inputs_uploadText__GGXtI {
    white-space: normal;
    word-break: break-word;
    max-width: 100%;
    padding: 0;
    line-height: 1.38;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
}

.inputs_fileInputComfortable__if-uf .inputs_fileInput__K3Nr5 {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 0;
}

.inputs_fileInputComfortableLabel__rrXT9 {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0.4rem 0.65rem;
  border-radius: 6px;
  background-color: #eef2f6;
  color: #3f4550;
  font-size: 12.5px;
  font-weight: 500;
  line-height: 1.35;
}

.inputs_fileInputComfortableHint__N6JVh {
  margin-top: 0.3rem;
  font-size: 11px;
  color: #6b7380;
  text-align: center;
  line-height: 1.35;
  width: 100%;
}

.inputs_fileList__QV8uY {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-content: start;
}

.inputs_fileItem__WFcKp {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    margin-right: 10px;
    border: grey solid 1px;
    border-radius: 3px;
}

.inputs_previewImage__nB9FI {
    border-radius: 3px;
    width: auto;
    height: 60px;
    object-fit: cover;
}

.inputs_defaultColorText__teA7Q {
    color: #DC3545;
    margin-right: 5px;
}

/* PRIMARY BUTTON (Aceptar, CONSULTAR, etc.) */

.inputs_primaryButton__Iw69C {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0.55rem 1.35rem;
    min-height: 2.5rem;
    font-family: inherit;
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: -0.02em;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    border: 1px solid transparent;
    border-radius: 10px;
    background: linear-gradient(180deg, #5b5ed0 0%, #4A4DBB 48%, #4245a8 100%);
    box-shadow:
        0 1px 2px rgba(15, 23, 42, 0.08),
        0 2px 8px rgba(74, 77, 187, 0.28);
    transition:
        background 0.15s ease,
        box-shadow 0.15s ease,
        transform 0.1s ease,
        filter 0.15s ease;
}

.inputs_primaryButton__Iw69C:hover {
    filter: brightness(1.05);
    box-shadow:
        0 2px 4px rgba(15, 23, 42, 0.1),
        0 4px 14px rgba(74, 77, 187, 0.35);
}

.inputs_primaryButton__Iw69C:active {
    transform: scale(0.98);
    filter: brightness(0.96);
}

.inputs_primaryButton__Iw69C:focus-visible {
    outline: none;
    box-shadow:
        0 0 0 3px rgba(129, 140, 248, 0.45),
        0 2px 8px rgba(74, 77, 187, 0.3);
}

/* CONSULTAR y acciones repetitivas — menos llamativo */
.inputs_primaryButtonQuiet__ZhXbE {
    background-image: none;
    background-color: #4a4dbf;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
    padding: 0.45rem 1.1rem;
    min-height: 2.375rem;
    font-size: 0.9375rem;
    font-weight: 600;
}

.inputs_primaryButtonQuiet__ZhXbE:hover {
    filter: brightness(1.06);
    box-shadow: 0 2px 6px rgba(74, 77, 187, 0.18);
}

.inputs_primaryButtonQuiet__ZhXbE:active {
    transform: scale(0.99);
}

.inputs_primaryButtonQuiet__ZhXbE:focus-visible {
    box-shadow:
        0 0 0 2px rgba(255, 255, 255, 0.9),
        0 0 0 5px rgba(129, 140, 248, 0.35);
}

/* SECONDARY BUTTON */

.inputs_secondaryButton__y4Jl1 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0.55rem 1.25rem;
    min-height: 2.5rem;
    font-family: inherit;
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: -0.02em;
    color: #334155;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    transition:
        background-color 0.12s ease,
        border-color 0.12s ease,
        color 0.12s ease,
        box-shadow 0.12s ease,
        transform 0.1s ease;
}

.inputs_secondaryButton__y4Jl1:hover {
    background: #f8fafc;
    border-color: #94a3b8;
    color: #0f172a;
}

.inputs_secondaryButton__y4Jl1:active {
    transform: scale(0.98);
}

.inputs_secondaryButton__y4Jl1:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.3);
}

/* Cerrar / cancelar (antes rojo plano; ahora acorde al shell) */

.inputs_dangerButton__Jnf8I {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0.55rem 1.25rem;
    min-height: 2.5rem;
    gap: 0.35rem;
    font-family: inherit;
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: -0.02em;
    color: #475569;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    transition:
        background-color 0.12s ease,
        border-color 0.12s ease,
        color 0.12s ease,
        box-shadow 0.12s ease,
        transform 0.1s ease;
}

.inputs_dangerBtnIcon__0juR9 {
    font-size: 0.85em;
    opacity: 0.85;
}

.inputs_dangerButton__Jnf8I:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    color: #0f172a;
}

.inputs_dangerButton__Jnf8I:hover .inputs_dangerBtnIcon__0juR9 {
    opacity: 1;
    color: #64748b;
}

.inputs_dangerButton__Jnf8I:active {
    transform: scale(0.98);
}

.inputs_dangerButton__Jnf8I:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.28);
}

/* Acciones riesgosas suaves — Desasociar, Quitar promesa (sin degradado llamativo) */
.inputs_dangerButtonDestructive__tQFVX {
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #991b1b;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    padding: 0.45rem 1.1rem;
    min-height: 2.375rem;
    font-size: 0.9375rem;
    font-weight: 600;
}

.inputs_dangerButtonDestructive__tQFVX:hover {
    background: #fee2e2;
    border-color: #fca5a5;
    color: #7f1d1d;
    filter: none;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.inputs_dangerButtonDestructive__tQFVX:active {
    transform: scale(0.99);
    filter: none;
}

.inputs_dangerButtonDestructive__tQFVX:focus-visible {
    outline: none;
    box-shadow:
        0 0 0 2px #ffffff,
        0 0 0 4px rgba(248, 113, 113, 0.4);
}

.inputs_floatingLabel__AcrTy {
    position: absolute;
    top: -10px;
    pointer-events: none;
    left: 12px;
    display: block;
    background-color: #FFFFFF;
    font-size: 0.8rem;
    padding-left: 3px;
    padding-right: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/input/inputs.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,0DAA0D;AAC9D;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;IACxB,yDAAyD;AAC7D;;AAEA,UAAU;;AAEV;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,WAAW;;AAEX;IACI,kBAAkB;IAClB,uIAAuI;IACvI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,0DAA0D;AAC9D;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB;;6CAEyC;IACzC,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,SAAS;;AAET;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA,+FAA+F;AAC/F;IACI,WAAW;AACf;;AAEA,4DAA4D;AAC5D;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB;;+BAE6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,iDAAiD;AACjD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,8CAA8C;;AAE9C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,0EAA0E;IAC1E;;yCAEqC;IACrC;;;;yBAIqB;AACzB;;AAEA;IACI,wBAAwB;IACxB;;0CAEsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb;;wCAEoC;AACxC;;AAEA,uDAAuD;AACvD;IACI,sBAAsB;IACtB,yBAAyB;IACzB,4CAA4C;IAC5C,uBAAuB;IACvB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;;2CAEuC;AAC3C;;AAEA,qBAAqB;;AAErB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;IAC5C;;;;;2BAKuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8CAA8C;AAClD;;AAEA,gEAAgE;;AAEhE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;IAC5C;;;;;2BAKuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,+CAA+C;AACnD;;AAEA,qFAAqF;AACrF;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,4CAA4C;IAC5C,uBAAuB;IACvB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb;;0CAEsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,UAAU;IACV,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".inputLabel {\n    text-align: left;\n    color: #4B5563;\n}\n\n.inputLabel:first-letter {\n    text-transform: uppercase;\n}\n\n.inputBorderDefault {\n    padding: 0.625rem 0.75rem !important;\n    border: 1px solid #e2e8f0 !important;\n    border-radius: 8px !important;\n    font-size: 1rem !important;\n    color: #334155 !important;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.inputBorderDefault:focus {\n    border-color: #818cf8 !important;\n    outline: none !important;\n    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.2) !important;\n}\n\n/* RADIO */\n\n.customRadio {\n    display: flex;\n    flex-direction: column;\n}\n\n.customRadio .radioOption {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.3rem;\n}\n\n.customRadio input[type=\"radio\"] {\n    display: none;\n}\n\n.customRadio label {\n    display: inline-block;\n    position: relative;\n    padding-left: 1.8rem;\n    cursor: pointer;\n    font-size: 16px;\n    color: #6B728C;\n}\n\n.customRadio label:before {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 1.2rem;\n    height: 1.2rem;\n    border: 1px solid #D9DDE2;\n    border-radius: 50%;\n}\n\n.customRadio label:after {\n    content: \"\";\n    display: none;\n    position: absolute;\n    left: 0.25rem;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 0.7rem;\n    height: 0.7rem;\n    background-color: #4A4DBB;\n    border-radius: 50%;\n}\n\n.customRadio input[type=\"radio\"]:checked + label:before {\n    border: 1px solid #4A4DBB;\n}\n\n.customRadio input[type=\"radio\"]:checked + label:after {\n    display: inline-block;\n}\n\n/* SELECT */\n\n.customSelect {\n    position: relative;\n    /* Sin clip aquí: .floatingLabel es absolute y textos largos quedarían recortados; el botón ya limita el texto con overflow-x: hidden */\n    overflow: visible;\n}\n\n.customSelectOpen {\n    z-index: 200;\n}\n\n.customSelect .dropdownButton {\n    height: 43px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.625rem 0.75rem;\n    font-size: 1rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background-color: #fff;\n    cursor: pointer;\n    color: #334155 !important;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    white-space: nowrap;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.customSelect .dropdownButton:focus-visible,\n.customSelect .dropdownButton:hover {\n    border-color: #94a3b8;\n}\n\n.customSelect .dropdownButton:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.2);\n}\n\n.customSelect .dropdownOptions {\n    color: #334155;\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    right: 0;\n    display: none;\n    background-color: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    box-shadow:\n        0 10px 15px -3px rgba(15, 23, 42, 0.08),\n        0 4px 6px -4px rgba(15, 23, 42, 0.06);\n    cursor: pointer;\n    z-index: 100;\n    overflow: hidden;\n    text-align: left;\n}\n\n.customSelect .dropdownOptions.show {\n    display: block;\n}\n\n.dropdownOption {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.95rem;\n    font-weight: 500;\n    text-align: left;\n    border-bottom: 1px solid #f1f5f9;\n    background-color: #fff;\n}\n\n.dropdownOption:last-child {\n    border-bottom: none;\n}\n\n.dropdownOptionTinted {\n    background-color: #f8fafc;\n}\n\n.dropdownOption:hover {\n    background-color: #f1f5f9 !important;\n}\n\n.dropdownOptionSelected {\n    background-color: #eef2ff !important;\n    color: #3730a3 !important;\n    font-weight: 600 !important;\n}\n\n/* FILE */\n\n.fileInputOutsideContainer {\n    background-color: #FFFFFF;\n    border-radius: 6px;\n    margin: 0 0 0 0;\n}\n\n.fileInputContainer {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n}\n\n.fileInput {\n    position: relative;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    border-color: #333;\n    border-radius: 5px;\n}\n\n.fileInput:focus {\n    border: 1px dashed #4A4DB9;\n}\n\n.uploadText {\n    text-align: center;\n    color: #333333CC;\n    white-space: nowrap;\n    font-size: 14px;\n}\n\n/* Modo cómodo (modal Subir documento): clase raíz por si hijos usan selectores descendientes */\n.fileInputComfortable {\n    width: 100%;\n}\n\n/* Zona dashed — modal Subir documento (finura + centrado) */\n.fileInputComfortableDrop {\n  border: 1px dashed #c5cad3;\n  border-radius: 8px;\n  min-height: 3.875rem;\n  padding: 0.5rem 0.625rem !important;\n  margin-bottom: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: center;\n  background-color: #fafbfc;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.fileInputComfortableDropActive {\n  border-color: #818cf8;\n  background-color: rgba(99, 102, 241, 0.04);\n}\n\n/* Zona de drop más amplias (texto multi-línea) */\n.fileInputComfortable .uploadText {\n    white-space: normal;\n    word-break: break-word;\n    max-width: 100%;\n    padding: 0;\n    line-height: 1.38;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    text-align: center;\n}\n\n.fileInputComfortable .fileInput {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 0;\n}\n\n.fileInputComfortableLabel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.4rem 0.65rem;\n  border-radius: 6px;\n  background-color: #eef2f6;\n  color: #3f4550;\n  font-size: 12.5px;\n  font-weight: 500;\n  line-height: 1.35;\n}\n\n.fileInputComfortableHint {\n  margin-top: 0.3rem;\n  font-size: 11px;\n  color: #6b7380;\n  text-align: center;\n  line-height: 1.35;\n  width: 100%;\n}\n\n.fileList {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: row;\n    align-content: start;\n}\n\n.fileItem {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n    margin-right: 10px;\n    border: grey solid 1px;\n    border-radius: 3px;\n}\n\n.previewImage {\n    border-radius: 3px;\n    width: auto;\n    height: 60px;\n    object-fit: cover;\n}\n\n.defaultColorText {\n    color: #DC3545;\n    margin-right: 5px;\n}\n\n/* PRIMARY BUTTON (Aceptar, CONSULTAR, etc.) */\n\n.primaryButton {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    padding: 0.55rem 1.35rem;\n    min-height: 2.5rem;\n    font-family: inherit;\n    font-size: 1rem;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n    text-align: center;\n    color: #ffffff;\n    cursor: pointer;\n    user-select: none;\n    border: 1px solid transparent;\n    border-radius: 10px;\n    background: linear-gradient(180deg, #5b5ed0 0%, #4A4DBB 48%, #4245a8 100%);\n    box-shadow:\n        0 1px 2px rgba(15, 23, 42, 0.08),\n        0 2px 8px rgba(74, 77, 187, 0.28);\n    transition:\n        background 0.15s ease,\n        box-shadow 0.15s ease,\n        transform 0.1s ease,\n        filter 0.15s ease;\n}\n\n.primaryButton:hover {\n    filter: brightness(1.05);\n    box-shadow:\n        0 2px 4px rgba(15, 23, 42, 0.1),\n        0 4px 14px rgba(74, 77, 187, 0.35);\n}\n\n.primaryButton:active {\n    transform: scale(0.98);\n    filter: brightness(0.96);\n}\n\n.primaryButton:focus-visible {\n    outline: none;\n    box-shadow:\n        0 0 0 3px rgba(129, 140, 248, 0.45),\n        0 2px 8px rgba(74, 77, 187, 0.3);\n}\n\n/* CONSULTAR y acciones repetitivas — menos llamativo */\n.primaryButtonQuiet {\n    background-image: none;\n    background-color: #4a4dbf;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n    padding: 0.45rem 1.1rem;\n    min-height: 2.375rem;\n    font-size: 0.9375rem;\n    font-weight: 600;\n}\n\n.primaryButtonQuiet:hover {\n    filter: brightness(1.06);\n    box-shadow: 0 2px 6px rgba(74, 77, 187, 0.18);\n}\n\n.primaryButtonQuiet:active {\n    transform: scale(0.99);\n}\n\n.primaryButtonQuiet:focus-visible {\n    box-shadow:\n        0 0 0 2px rgba(255, 255, 255, 0.9),\n        0 0 0 5px rgba(129, 140, 248, 0.35);\n}\n\n/* SECONDARY BUTTON */\n\n.secondaryButton {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    padding: 0.55rem 1.25rem;\n    min-height: 2.5rem;\n    font-family: inherit;\n    font-size: 1rem;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n    color: #334155;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #cbd5e1;\n    border-radius: 10px;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n    transition:\n        background-color 0.12s ease,\n        border-color 0.12s ease,\n        color 0.12s ease,\n        box-shadow 0.12s ease,\n        transform 0.1s ease;\n}\n\n.secondaryButton:hover {\n    background: #f8fafc;\n    border-color: #94a3b8;\n    color: #0f172a;\n}\n\n.secondaryButton:active {\n    transform: scale(0.98);\n}\n\n.secondaryButton:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.3);\n}\n\n/* Cerrar / cancelar (antes rojo plano; ahora acorde al shell) */\n\n.dangerButton {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    padding: 0.55rem 1.25rem;\n    min-height: 2.5rem;\n    gap: 0.35rem;\n    font-family: inherit;\n    font-size: 1rem;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n    color: #475569;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n    transition:\n        background-color 0.12s ease,\n        border-color 0.12s ease,\n        color 0.12s ease,\n        box-shadow 0.12s ease,\n        transform 0.1s ease;\n}\n\n.dangerBtnIcon {\n    font-size: 0.85em;\n    opacity: 0.85;\n}\n\n.dangerButton:hover {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #0f172a;\n}\n\n.dangerButton:hover .dangerBtnIcon {\n    opacity: 1;\n    color: #64748b;\n}\n\n.dangerButton:active {\n    transform: scale(0.98);\n}\n\n.dangerButton:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.28);\n}\n\n/* Acciones riesgosas suaves — Desasociar, Quitar promesa (sin degradado llamativo) */\n.dangerButtonDestructive {\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    color: #991b1b;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n    padding: 0.45rem 1.1rem;\n    min-height: 2.375rem;\n    font-size: 0.9375rem;\n    font-weight: 600;\n}\n\n.dangerButtonDestructive:hover {\n    background: #fee2e2;\n    border-color: #fca5a5;\n    color: #7f1d1d;\n    filter: none;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.dangerButtonDestructive:active {\n    transform: scale(0.99);\n    filter: none;\n}\n\n.dangerButtonDestructive:focus-visible {\n    outline: none;\n    box-shadow:\n        0 0 0 2px #ffffff,\n        0 0 0 4px rgba(248, 113, 113, 0.4);\n}\n\n.floatingLabel {\n    position: absolute;\n    top: -10px;\n    pointer-events: none;\n    left: 12px;\n    display: block;\n    background-color: #FFFFFF;\n    font-size: 0.8rem;\n    padding-left: 3px;\n    padding-right: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputLabel": `inputs_inputLabel__cmL1u`,
	"inputBorderDefault": `inputs_inputBorderDefault__vNi7I`,
	"customRadio": `inputs_customRadio__vWOKw`,
	"radioOption": `inputs_radioOption__wAzPr`,
	"customSelect": `inputs_customSelect__Utjd+`,
	"customSelectOpen": `inputs_customSelectOpen__iMV3X`,
	"dropdownButton": `inputs_dropdownButton__fl-JL`,
	"dropdownOptions": `inputs_dropdownOptions__2xnyY`,
	"show": `inputs_show__sqIM1`,
	"dropdownOption": `inputs_dropdownOption__w0t3p`,
	"dropdownOptionTinted": `inputs_dropdownOptionTinted__fx+0O`,
	"dropdownOptionSelected": `inputs_dropdownOptionSelected__lgiEI`,
	"fileInputOutsideContainer": `inputs_fileInputOutsideContainer__HuJnR`,
	"fileInputContainer": `inputs_fileInputContainer__la0Xk`,
	"fileInput": `inputs_fileInput__K3Nr5`,
	"uploadText": `inputs_uploadText__GGXtI`,
	"fileInputComfortable": `inputs_fileInputComfortable__if-uf`,
	"fileInputComfortableDrop": `inputs_fileInputComfortableDrop__TuTb5`,
	"fileInputComfortableDropActive": `inputs_fileInputComfortableDropActive__z6D7u`,
	"fileInputComfortableLabel": `inputs_fileInputComfortableLabel__rrXT9`,
	"fileInputComfortableHint": `inputs_fileInputComfortableHint__N6JVh`,
	"fileList": `inputs_fileList__QV8uY`,
	"fileItem": `inputs_fileItem__WFcKp`,
	"previewImage": `inputs_previewImage__nB9FI`,
	"defaultColorText": `inputs_defaultColorText__teA7Q`,
	"primaryButton": `inputs_primaryButton__Iw69C`,
	"primaryButtonQuiet": `inputs_primaryButtonQuiet__ZhXbE`,
	"secondaryButton": `inputs_secondaryButton__y4Jl1`,
	"dangerButton": `inputs_dangerButton__Jnf8I`,
	"dangerBtnIcon": `inputs_dangerBtnIcon__0juR9`,
	"dangerButtonDestructive": `inputs_dangerButtonDestructive__tQFVX`,
	"floatingLabel": `inputs_floatingLabel__AcrTy`
};
export default ___CSS_LOADER_EXPORT___;
